import styled from 'styled-components'

export const WelcomePageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`

export const LeftPanel = styled.div`
  width: 40%;
  background-color: #1e3a5f;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;

  @media (max-width: 900px) {
    display: none;
  }
`

export const LogoWrapper = styled.div`
  svg {
    width: 280px;
    height: auto;
  }
`

export const RightPanel = styled.div`
  flex: 1;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem;

  @media (max-width: 900px) {
    padding: 2rem 1rem;
  }
`

export const ContentWrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
  width: 100%;
`

export const HeaderSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 2.5rem;

  h1 {
    font-size: 1.75rem;
    font-weight: 600;
    color: #1e3a5f;
    margin: 0 0 0.75rem 0;
    line-height: 1.3;
  }

  p {
    font-size: 1rem;
    color: ${({ theme }) => theme.input.default.placeholder};
    margin: 0;
    line-height: 1.5;
  }
`

export const SuperheroImage = styled.div`
  flex-shrink: 0;
  min-width: 180px;

  svg {
    width: 250px;
    height: auto;
  }

  @media (max-width: 768px) {
    min-width: 120px;
    svg {
      width: 150px;
    }
  }

  @media (max-width: 500px) {
    display: none;
  }
`

export const PlansContainer = styled.div`
  display: flex;
  gap: 1.5rem;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

export const PlanBox = styled.div`
  flex: 1;
  background: #f9fafb;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
`

export const PlanHeader = styled.div<{ $variant: 'trial' | 'after' }>`
  padding: 0.75rem 1rem;
  text-align: center;
  font-weight: 600;
  font-size: 0.875rem;
  color: #fff;
  background-color: ${({ theme, $variant }) =>
    $variant === 'trial' ? theme.color.primary : '#697c93'};
`

export const PlanContent = styled.div`
  padding: 1.25rem;
`

export const PlanTitle = styled.div`
  margin-bottom: 0.5rem;

  h3 {
    font-size: 1.125rem;
    font-weight: 600;
    color: #1e3a5f;
    margin: 0;
  }
`

export const PlanDescription = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.input.default.placeholder};
  margin: 0 0 1rem 0;
  line-height: 1.4;
`

export const PlanLabel = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.input.default.placeholder};
  margin-bottom: 0.5rem;
  display: block;
`

export const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.35rem 0;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.input.default.color};

    svg {
      color: ${({ theme }) => theme.color.primary};
      flex-shrink: 0;
    }
  }
`

export const FeatureNote = styled.p`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.input.default.placeholder};
  margin: 0.75rem 0 0 0;
  font-style: italic;
`

export const FooterSection = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
`
